import React from 'react';

import { HStack } from '@/shared/ui';

type LoadingProps = {
  visible: boolean;
  type?: 'dots' | 'oval';
  w?: number;
  mx?: number;
};

const SpinnerDots = ({ size = 24 }: { size: number }) => (
  <div
    style={{
      width: size,
      height: size / 4,
      backgroundColor: 'currentColor',
      borderRadius: size / 8,
      animation: 'dots 1s infinite ease-in-out',
    }}
  />
);

const SpinnerOval = ({ size = 24 }: { size: number }) => (
  <div
    style={{
      width: size,
      height: size,
      border: `${size / 8}px solid currentColor`,
      borderTopColor: 'transparent',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    }}
  />
);

export const Loading: React.FC<LoadingProps> = ({ visible, type = 'dots', w = 24, mx }) => {
  if (!visible) {
    return null;
  }

  return (
    <HStack
      className="w-full"
      justify="center"
      align="center"
      style={{ marginLeft: mx ?? undefined, marginRight: mx ?? undefined }}
    >
      {type === 'dots' ? <SpinnerDots size={w} /> : <SpinnerOval size={w} />}
    </HStack>
  );
};
